module.exports = __webpack_public_path__ + "img/HKUST(GZ)_logo.dd555ddd.svg";